<template>
    <div id="index">
      <!-- <Hezuo></Hezuo> -->

        <div class="visible-xs min_index">
            <header class="flex_center m_header">
                <i class="esc" @click="goBackward"><img src="@/assets/img/esc_fan.png" alt=""></i>
                <h4 class="header_title">系统消息</h4>
            </header>
            <!-- 内容 -->
            <div class='comments_ul li_r_img' v-html="list_obj.content">

            </div>
        </div>
    </div>
</template>

<script>
import Hezuo from '@/components/tool/m_hezuo.vue'

    export default {
        name: "index",
        data() {
            return {
                user: {},//用户信息
                list_obj: {},

            };
        },
        computed: {

        },
        components: {
Hezuo
        },
        watch: {

        },
        methods: {

            goBackward() {//返回上一页
                this.$router.go(-1)
            },
            getUser() {
                let that = this;
                this.REFRESH_USER();
                that.user = this.USER();
                that.read();

            },
            read() {//获取列表数据
                let that = this;
                this.$post('read', {
                    member_id: this.USER().id,
                    message_id: this.list_obj.message_id,
                }).then(res => {

                })
            },
            addImg() {
                $('.li_r_img img').on("click", function () {
                    $(this).ImgZoomIn('');
                });
            },

        },
        activated(){
             this.list_obj = this.$route.query;
            this.list_obj.content = this.list_obj.content.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ')
            this.getShare();
            this.getUser();
            let that = this;
            this.$nextTick(() => {
                that.addImg();
            })
            if (this._isMobile()) {

            } else {
                // alert("pc端");
                this.$router.replace("/");
            } 
        },
        mounted() {
            this.list_obj = this.$route.query;
            this.list_obj.content = this.list_obj.content.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ')
            this.getShare();
            this.getUser();
            let that = this;
            this.$nextTick(() => {
                that.addImg();
            })
            if (this._isMobile()) {

            } else {
                // alert("pc端");
                this.$router.replace("/");
            }

        }
    };
</script>

<style scoped>
    html,
    body {
        max-width: 100vw;
    }


    .visible-xs {
        width: 100vw;
        overflow: hidden;
        padding-top: 0rem;
    }

    /* 内容 */
    .comments_ul {
        padding: 1rem 1.8rem;
        font-size: 1.5rem;
        color: #333;
        max-width: 100vw;
    }
</style>


// WEBPACK FOOTER //
// src/components/min_view/m_message_details.vue